export default __webpack_public_path__ + "src/images/packages/summerfields-rose-retreat/b40aadfeea92e2b53333517f185f054a-1.jpg";